<div class="structure" *ngIf="company">
  <company-department [department]="department" [editable]="editable" [active]="true"></company-department>
  <company-member [member]="member" [editable]="editable" *ngFor="let member of members"></company-member>
</div>
